import { REDUCER_NAME } from './const'
import { ALIGNER_SYSTEM_ALIGNERS_PER_STEP } from '../quotation/const'
import { selectOwnState as selectParentState } from '../selector'
import { selectSalesOrder } from '../../../sales-order/state/detail/selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectTreatmentPlan = state => {
    return selectOwnState(state).treatmentPlan
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectAlignerLabelList = (state, salesOrder) => {
    if (!salesOrder) {
        return []
    }

    if (salesOrder.type === 'retainer' || salesOrder.type === 'retainer-new') {
        return [
            {
                upper: '-R-U',
                lower: '-R-L',
            },
        ]
    }

    if (salesOrder.type === 'retainer-refinement') {
        return [
            {
                upper: '-RR-U',
                lower: '-RR-L',
            },
        ]
    }

    if (salesOrder.type === 'retainer-refinement-new') {
        return [
            {
                upper: '-RR-U',
                lower: '-RR-L',
            },
        ]
    }

    const treatmentPlan = selectTreatmentPlan(state)
    if (!treatmentPlan) {
        return []
    }

    const { numberOfAlignerUpperJaw, numberOfAlignerLowerJaw } = treatmentPlan

    const maxNumber = numberOfAlignerUpperJaw > numberOfAlignerLowerJaw ? numberOfAlignerUpperJaw : numberOfAlignerLowerJaw

    const alignerLabelList = []

    for (let index = 1; index <= maxNumber; index++) {
        // let week = ((index % 3) === 0) ? '2W' : '1W';
        const step = (index < 10) ? '0' + index : index

        alignerLabelList.push({
            upper: index <= numberOfAlignerUpperJaw ? '-' + step + '-U' : null,
            lower: index <= numberOfAlignerLowerJaw ? '-' + step + '-L' : null,
        })
    }
    return alignerLabelList
}

export const selectAlignerLabelListReproduction = (state) => {
    const salesOrder = selectSalesOrder(state)
    const customer = salesOrder.customer
    const salesOrderList = customer.salesOrderList
    const isProductionSalesOrder = (type) => (type === 'retainer' || type === 'retainer-new' || type === 'treatment' || type === 'refinement-production')

    return salesOrderList.filter((salesOrder) => isProductionSalesOrder(salesOrder.type)).map((currentSalesOrder) => {
        return {
            salesOrderType: currentSalesOrder.type,
            salesOrderReference: currentSalesOrder.referenceNumber,
            labelList: selectAlignerLabelList(state, currentSalesOrder),
        }
    })
}

export const selectAlignerLabelListProduction = (state) => {
    const salesOrder = selectSalesOrder(state)
    const alignerLabeList = []
    const alignerLabel = {
        salesOrderType: salesOrder.type,
        salesOrderReference: salesOrder.referenceNumber,
        labelList: selectAlignerLabelList(state, salesOrder),
    }
    alignerLabeList.push(alignerLabel)

    return alignerLabeList
}

export const selectAlignersPerStepList = () => {
    return ALIGNER_SYSTEM_ALIGNERS_PER_STEP
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/plan/selector.js